<h4 class="mb-4">New document</h4>
<div class="mb-4 d-flex gap-3 align-items-center">
  <button type="button" class="btn btn-primary" (click)="onNewClientDocumentClicked()">New Client Document</button>
  <button type="button" class="btn btn-primary" (click)="onNewGeneralDocumentClicked()">New General Document</button>
</div>

<div *ngIf="isClientDocument" class="d-flex align-items-center gap-3">
  <label>Select the Client Case:</label>

  <div class="flex-fill">
    <tx-client-case-tree (caseSelected)="onCaseSelected($event)"></tx-client-case-tree>
  </div>
</div>

<form
  ngNoForm
  [action]="submitUrl"
  method="post"
  enctype="application/x-www-form-urlencoded"
  target="_blank"
  #openInNewTabForm>
  <input type="hidden" [id]="sessionId" [name]="sessionId" />
  <input type="hidden" id="casId" name="casId" />
  <input type="hidden" id="ctcId" name="ctcId" />
</form>
